export enum VoiceStatus {
  Unready = "unready",
  Loading = "loading",
  Ready = "ready",
  Playing = "playing",
}

export const iconClassMap = {
  [VoiceStatus.Unready]: "site-icon-play",
  [VoiceStatus.Loading]: "site-icon-loading",
  [VoiceStatus.Ready]: "site-icon-play",
  [VoiceStatus.Playing]: "site-icon-pause",
};

export const iconMap = {
  [VoiceStatus.Unready]: "el-icon-video-play",
  [VoiceStatus.Loading]: "el-icon-loading",
  [VoiceStatus.Ready]: "el-icon-video-play",
  [VoiceStatus.Playing]: "el-icon-video-pause",
};

export enum GeneratedVoiceStatus {
  PENDING = "PENDING",
  RUNNING = "RUNNING",

  SUCCESSED = "SUCCESSED",
  SUCCEEDED = "SUCCEEDED",

  FAILED = "FAILED",
  CANCELED = "CANCELED",
  SUSPENDED = "SUSPENDED",
  UNKNOWN = "UNKNOWN",
}
